import { ReactNode } from 'react';

interface DocumentListReviewProps {
  children: ReactNode;
}

export default function DocumentListReview({ children }: DocumentListReviewProps): JSX.Element {
  return (
    <div className="flex flex-col self-left items-left lg:items-start text-left py-2 gap-y-3 sm:min-w-4/5 md:min-w-2/3 lg:min-w-7/12">
      <div className="flex flex-col justify-between gap-y-4">
        <div className="flex flex-col w-full gap-y-4">{children}</div>
      </div>
    </div>
  );
}
